export enum CANVAS_INTERACTION_STATE {
  IDLE = 'IDLE',
  TRANSFORMING = 'TRANSFORMING',
  PANNING = 'PANNING',
  EDITING = 'EDITING',
  DRAGGING = 'DRAGGING',

  /*
  TODO: Change this so only have higher level states like DRAWING, EDITING etc
  type of current object like bbox or mask is not an interaction state, it's metadata to be stored elsewhere
  due to this choice we have to temporarily create derived views like isDrawing & isEditing :(
*/
  DRAWING_POLYGON = 'DRAWING_POLYGON',
  DRAWING_BOX = 'DRAWING_BOX',
  DRAWING_MASK = 'DRAWING_MASK',
  DRAWING_POINT = 'DRAWING_POINT',
  DRAWING_POINT_POSITIVE = 'DRAWING_POINT_POSITIVE',
  DRAWING_POINT_NEGATIVE = 'DRAWING_POINT_NEGATIVE',
}

export const MEDIA_GROUP_ID = 'media-group';

export type Coordinates = {
  x: number;
  y: number;
};

export type MakeGetRestrictedPosition = (args: {
  containerDimensions: { width: number; height: number };
  dimensions?: { width: number; height: number };
  scale?: number;
}) => (c: Coordinates) => Coordinates;

export enum DISPLAY_ACTION_STATE {
  BRIGHTNESS = 'BRIGHTNESS',
  SATURATION = 'SATURATION',
  CONTRAST = 'CONTRAST',
  INVERT_COLORS = 'INVERT_COLORS',
  ROTATE = 'ROTATE',
  SAVED_LOCALLY = 'SAVED_LOCALLY',
}
